<template>


    <div class="podcast-player-wrap">

        <div class="header">
            <div class="goal-image">
                <img :src="podcast.global_goal_image" alt="">
            </div>
            <div class="podcast-info">
                <h1 class="title">{{ podcast.name }}</h1>
                <div class="desc">{{ podcast.description }}</div>
            </div>
<!--             <div class="actions">
                <a href="#" class="share">Share this Podcast</a>
                <a v-if="showClose" class="close" @click="close()">&times;</a>
            </div> -->
        </div>


        <div class="player-body podcast-player"
             ref="player"
             tabindex="-1"
             @keyup.stop.space="togglePlay()"
             @keydown.stop.left="seek( stats.timestamp - 10 )"
             @keydown.stop.right="seek( stats.timestamp + 10 )"
             @keydown.stop.ctrl.left="prev()"
             @keydown.stop.ctrl.right="next()"
             :class="[podcast.type, stats.show_controls ? 'show-controls' : 'hide-controls', stats.fullscreen ? 'is-fullscreen' : '']">
            <div class="player-wrap">
                <div class="player"
                     @mousemove="showControls()">
<!--                    :style="stickyAt ? {top: `${stickyAt}px`} : {}"-->
                    <div class="player-preview"
                         ref="preview"
                         @dblclick.prevent.stop="toggleFullscreen()"
                         @click.prevent.stop="togglePlay()"
                         :class="{'showing-visuals': stats.show_visuals}"
                         :style="`background-image: url(${preview_url_large})`">
                    </div>
                    <div class="player-controls"
                         @mouseover="forceControls(true)"
                         @mouseleave="forceControls(false)">
                        <div class="basic-controls">
                            <a href="#" class="prev" @click.prevent.stop="prev()">
                                <icon-fast-backward class="icon"/>
                            </a>
                            <a href="#" class="play" @click.prevent.stop="togglePlay()">
                                <icon-pause v-if="stats.is_playing" class="icon"/>
                                <icon-play v-else class="icon"/>
                            </a>
                            <a href="#" class="next" @click.prevent.stop="next()">
                                <icon-fast-forward class="icon"/>
                            </a>
                        </div>
                        <div class="timer">
                            <span>{{ utils.timestampToText( stats.timestamp ) }}</span> /
                            <span>{{ utils.timestampToText( stats.duration ) }}</span>
                        </div>
                        <div class="seeker-control">
                            <div class="track" ref="track" @click.stop="onProgressClick">
                                <div class="steps" v-if="stats.duration">
                                    <a class="step" v-for="step in transcripts" :key="step.timestamp"
                                       href="#"
                                       :style="{left: Math.min(100 / stats.duration * step.timestamp, 100) + '%' }"
                                       @click.prevent.stop="seek(step.timestamp)"
                                       :title="step.title">
                                        <span class="text">{{ step.title }}</span>
                                    </a>
                                </div>
                                <div class="complete" :style="{width: `${progress}%`}">
                                    <div class="handle"></div>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <div class="btn-group">
                                <div href="#"
                                     class="btn btn-volume"
                                     :class="stats.volume_muted ? 'btn-danger' : 'btn-dark'"
                                     @wheel.prevent.stop="onVolumeWheel"
                                     @click.prevent.stop="toggleMute()">

                                    <icon-volume-mute size="16" v-if="stats.volume_muted"/>
                                    <icon-volume-low size="16" v-else-if="stats.volume < 35"/>
                                    <icon-volume-medium size="16" v-else-if="stats.volume < 70"/>
                                    <icon-volume-high size="16" v-else/>

                                    <div class="volume-control" @click.stop.prevent>
                                        <input type="range" min="0" max="100" step="1" v-model="stats.volume" orient="vertical">
                                    </div>
                                </div>
                                <a href="#"
                                   class="btn"
                                   :class="stats.fullscreen ? 'btn-primary' : 'btn-dark'"
                                   :title="stats.fullscreen ? 'Restore' : 'Fullscreen'"
                                   @click.prevent.stop="toggleFullscreen()">
                                    <icon-fullscreen-restore size="16" v-if="stats.fullscreen" />
                                    <icon-fullscreen size="16" v-else />
                                </a>
                                <a v-if="!hideSidebar" href="#"
                                   class="btn"
                                   :class="stats.sidebar ? 'btn-primary' : 'btn-primary'"
                                   @click.prevent.stop="toggleSidebar()">
                                    <template v-if="stats.sidebar === 'details' && has_transcript != null">
                                        TRANSCRIPT
                                    </template>
                                    <template v-else-if="stats.sidebar === 'transcript'">
                                        EXPAND
                                    </template>
                                    <template v-else>
                                        INFO
                                    </template>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="player-sidebar" v-if="stats.sidebar">
                    <template v-if="stats.sidebar === 'details'">

                        <div v-if="current_user" class="flex-grow w-100 pr-4 d-flex flex-column align-items-center pt-3">

                            <p class="text-left mb-4">
                                After playing this podcast, engage your students more with these activities
                                that build a great understanding of the issue and inspire action.
                            </p>

                            <div class="w-100">
                                <carousel>
                                    <carousel-slide v-for="(activity, index) in activities" :key="activity.id"
                                                    :class="{active: index === 0}">
                                        <canvas-element-card :element="activity"
                                                             preview-priority="attachment"
                                                             :show-edit="false"
                                                             :show-download="true"
                                                             :show-groups="false"/>
                                    </carousel-slide>
                                </carousel>
                            </div>


<!--                            <pre>{{ activities }}</pre>-->
<!--                            <carousel :items-to-show="1"-->
<!--                                      :wrap-around="true"-->
<!--                                      class="w-100">-->

<!--                                <slide v-for="activity in activities" :key="activity.id">-->
<!--                                    <canvas-element-card :element="activity"-->
<!--                                                         :show-edit="false"-->
<!--                                                         :show-groups="false"/>-->
<!--                                </slide>-->

<!--                                <template #addons>-->
<!--                                    <navigation />-->
<!--                                    <pagination />-->
<!--                                </template>-->
<!--                            </carousel>-->

                        </div>

                        <form v-else
                              action="#"
                              method="post"
                              class="details"
                              @submit.prevent.stop="downloadToolkit">
                            <img src="/images/podcast/activity_fqqc.png"
                                 srcset="/images/podcast/activity_fqqc.png 1x, /images/podcast/activity_fqqc@2x.png 2x">
                            <h3>Go Beyond The Podcast</h3>
                            <p>
                                Get access to dozens of free hands-on activities<br/>that you can use in your classroom today.
                            </p>
                            <div class="custom-control custom-checkbox mb-3">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       v-model="download_toolkit.form.subscribe"
                                       :disabled="download_toolkit.form.processing"
                                       id="check-subscribe">
                                <label class="custom-control-label" for="check-subscribe">
                                    Keep me informed about new podcasts
                                </label>
                            </div>
                            <div class="input-group mb-3">
                                <input type="text"
                                       class="form-control"
                                       v-model="download_toolkit.form.email"
                                       :disabled="download_toolkit.form.processing"
                                       placeholder="Your Email">
                                <div class="input-group-append">
                                    <button type="submit"
                                            :disabled="download_toolkit.form.processing || ! download_toolkit_form_is_valid"
                                            class="btn btn-feel">
                                        Get Access
                                    </button>
                                </div>
                            </div>

                            <div v-if="download_toolkit.form.recentlySuccessful" class="text-success font-weight-bold">
                                <icon-check class="success" :size="16"/> Thank you!<br>Please check your email for further details.
                            </div>

                        </form>

                    </template>
                    <template v-if="stats.sidebar === 'transcript'">
                        <div class="transcripts">
                            <h4 class="sticky-top bg-white py-1">{{ active_transcript?.title }}</h4>
                            <div class="segment" v-for="segment in active_transcript?.segments" :key="segment.text">
                                <h6>{{ segment.speaker }}</h6>
                                <p>{{ segment.text }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import API from "@/API";
import {validate} from "@/helpers/validate";
import Vimeo from "@vimeo/player/dist/player";
import IconPlay from "@/Icons/IconPlay";
import IconPause from "@/Icons/IconPause";
import IconFastForward from "@/Icons/IconFastForward";
import IconFastBackward from "@/Icons/IconFastBackward";
import jQuery from "jquery";
import IconFullscreen from "@/Icons/IconFullscreen";
import IconFullscreenRestore from "@/Icons/IconFullscreenRestore";
import IconVolumeHigh from "@/Icons/IconVolumeHigh";
import IconVolumeLow from "@/Icons/IconVolumeLow";
import IconVolumeMute from "@/Icons/IconVolumeMute";
import IconVolumeMedium from "@/Icons/IconVolumeMedium";
import CanvasElementCard from "@/Components/CanvasElement/CanvasElementCard";
import Carousel from "@/Components/Common/Carousel";
import CarouselSlide from "@/Components/Common/CarouselSlide";
import IconCheck from "@/Icons/IconCheck";
import mixpanel from "mixpanel-browser";

let video = null;

export default {
    name: "PodcastPlayer",
    components: {
        IconCheck,
        CanvasElementCard,
        IconVolumeMedium,
        IconVolumeMute,
        IconVolumeLow,
        IconVolumeHigh,
        IconFullscreenRestore,
        IconFullscreen,
        IconFastBackward,
        IconFastForward,
        IconPause,
        IconPlay,
        Carousel,
        CarouselSlide
    },
    mixins: [utils, uploads],
    // props: ['podcast', 'showTitle', 'stickyAt'],
    props: {
        podcast: {
            type: Object,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        showDownload: {
            type: Boolean,
            default: true,
        },
        showStartProject: {
            type: Boolean,
            default: true,
        },
        stickyAt: {
            type: Number,
            default: 130,
        },
        showClose: {
            type: Boolean,
            default: false,
        },
        hideSidebar: {
            type: Boolean,
            default: false
        }
    },


    data(){
        return {

            is_busy: true,

            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: true,
                pageDots: false,
                wrapAround: true
            },

            audio: null,
            auto_hide_control_timer: null,
            forced_show_controls: false,

            stats: {
                volume: 100,
                volume_muted: false,
                timestamp: 0,
                duration: 0,
                is_playing: false,
                is_buffering: false,
                show_visuals: false,
                show_transcripts: false,
                show_controls: true,
                fullscreen: false,
                sidebar: 'details',
                current_index: -1,
            },
            transcripts: [],

            activities: [],


            download_toolkit: {
                form: this.$inertia.form({
                    subscribe: true,
                    email: '',
                }),
            },

        }
    },

    computed: {

        volume(){
            return this.stats.volume;
        },

        volume_muted(){
            return this.stats.volume_muted;
        },

        video: {
            get(){
                return video;
            },
            set(val){
                video = val;
            }
        },

        is_video(){
            return this.podcast?.type === 'video';
        },

        is_audio(){
            return this.podcast?.type === 'audio';
        },

        slug(){
            return this.podcast?.short_name;
        },

        vimeo_id(){
            return this.is_video ? this.podcast.url.split('/').pop() : null;
        },

        active_transcript(){
            return this.transcripts?.find(v => v.timestamp <= this.stats.timestamp);
        },

        has_transcript() {
            return this.podcast.transcript_file;
        },

        progress(){
            return this.stats.duration ? (this.stats.timestamp / this.stats.duration * 100) : 0;
        },

        preview_url_large(){
            return this.uploads.image(this.preview_url, {w:1200, h:1200, c:false});
        },

        preview_url(){

            if( this.is_audio ){
                return this.stats.show_visuals ? this.active_transcript?.visual : this.podcast.picture_large;
            }

            return this.stats.show_visuals ? null : this.podcast.picture_large;
        },

        create_project_url(){
            return this.route('project.create.with-podcast', {
                path: process.env.MIX_DEFAULT_LEARNING_PATH, // Should give a place for editing config.
                podcast: this.slug,
                ...this.global_url_params,
            });
        },

        create_short_project_url(){
            return this.route('project.create.with-podcast', {
                path: process.env.MIX_SHORT_LEARNING_PATH, // Should give a place for editing config.
                podcast: this.slug,
                ...this.global_url_params,
            });
        },


        download_toolkit_form_is_valid(){
            return this.download_toolkit.form.email.length && validate.email( this.download_toolkit.form.email );
        },

    },

    watch:{
        volume(volume){
            this.stats.volume_muted = volume <= 0;
            this.$cookies.set('volume', volume);
            this.updatePlayerVolume();
        },

        volume_muted(muted){
            this.$cookies.set('volume_muted', muted ? 1 : 0);
            this.updatePlayerVolume();
        }
    },

    methods: {
        downloadToolkit(){
            if( this.$page.props.user ){
                window.open(this.route('toolkit.download'), '_blank');
            }else{
                if( this.download_toolkit_form_is_valid ){
                    this.download_toolkit.form.post( this.route('toolkit.register-to-download'), {
                        only: [],
                        onSuccess: () => {
                            //this.download_toolkit.form.reset()
                        }
                    });
                }
            }
        },

        onFullscreenChange(ev){
            if( document.fullscreenElement ){
                if( document.fullscreenElement.isSameNode( this.$refs.player ) ){
                    this.stats.fullscreen = true;
                    this.fixHeight();
                    return;
                }
            }
            this.stats.fullscreen = false;
            this.fixHeight();
        },


        requestFullscreen(el) {

            const rfs = el.requestFullscreen
                || el.webkitRequestFullScreen
                || el.mozRequestFullScreen
                || el.msRequestFullscreen

            if( rfs ){
                rfs.call(el);
            }
        },

        exitFullscreen() {
            const efs = document.exitFullscreen
                || el.webkitExitFullScreen
                || el.mozExitFullScreen
                || el.msExitFullscreen

            if( efs ){
                efs.call(document);
            }
        },

        toggleFullscreen(){
            if( this.stats.fullscreen ){
                this.exitFullscreen();
            }else{
                this.requestFullscreen( this.$refs.player );
            }
        },

        toggleSidebar(){
            if( this.stats.sidebar === 'details' ){
                this.stats.sidebar = 'transcript';
            }else if(this.stats.sidebar === 'transcript'){
                this.stats.sidebar = null;
            }else{
                this.stats.sidebar = 'details';
            }
        },

        toggleMute(){
            this.stats.volume_muted = !this.stats.volume_muted;
            if( !this.stats.volume_muted && this.stats.volume <= 0 ){
                this.stats.volume = 10;
            }
        },


        onVolumeWheel(ev){
            let vol = this.stats.volume + (ev.wheelDeltaY / 30);
            if( vol < 0 ) vol = 0;
            if( vol > 100 ) vol = 100;
            this.stats.volume = vol;
        },

        onProgressClick(ev){
            const $track = jQuery( this.$refs.track );
            const x = ev.pageX - $track.offset().left;
            if( this.stats.duration <= 0 ) return;
            this.seek( (this.stats.duration / $track.width()) * x );
        },

        async onPlayerReady(){
            this.stats.timestamp = 0;
            if( this.is_video ){
                this.stats.duration = await this.video.getDuration();
            }else if( this.is_audio ){
                this.stats.duration = this.audio.duration;
            }

            await this.setCurrentIndex();

        },

        async onPlay(){
            this.stats.is_playing = true;
            this.stats.show_visuals = true;
            this.forceControls(false);
            mixpanel.track('PODCAST/PLAY', this.utils.flatten(this.podcast));
        },

        async onPause(){
            this.stats.is_playing = false;
        },

        async onEnded(){
            this.stats.is_playing = false;
            this.stats.timestamp = 0;
            this.forceControls(true);
        },

        async onBufferStart(){
            this.stats.is_buffering = true;
        },

        async onBufferEnd(){
            this.stats.is_buffering = false;
        },

        async updatePlayerVolume(){
            if( this.is_audio ){
                this.audio.volume = this.stats.volume / 100 * (!this.stats.volume_muted);
            }
            if( this.is_video ){
                this.video.setVolume( this.stats.volume / 100 * (!this.stats.volume_muted) );
            }
        },

        async onTimeupdate(ev){

            if( this.is_audio ){
                this.stats.timestamp = this.audio.currentTime;
            }

            if( this.is_video ){
                this.stats.timestamp = ev.seconds;
            }

            await this.setCurrentIndex();
            this.$forceUpdate();
        },

        async setCurrentIndex(){
            this.stats.current_index = this.transcripts ? this.transcripts.findIndex(t => t.timestamp <= this.stats.timestamp) : -1;
        },

        togglePlay(){
            if( this.stats.is_playing ){
                this.pause();
            }else{
                this.play();
            }
        },

        forceControls(force){
            this.forced_show_controls = force;
        },

        showControls(){
            this.stats.show_controls = true;
            this.autoHideControls(5);
        },

        hideControls(){
            this.stats.show_controls = this.forced_show_controls;
        },

        autoHideControls(secs){

            if( this.auto_hide_control_timer ){
                clearTimeout(this.auto_hide_control_timer);
            }

            this.auto_hide_control_timer = setTimeout(() => {
                this.hideControls();
            }, secs * 1000);
        },

        async seek(secs){

            if( secs < 0 ) secs = 0;
            if( secs > this.stats.duration ) secs = this.stats.duration - 1;

            if( this.is_audio ){
                this.audio.currentTime = secs;
            }
            if( this.is_video ){
                await this.video.setCurrentTime(secs);
            }

            if( !this.stats.is_playing ){
                await this.play();
            }

        },

        async gotoIndex(index){
            if( index > this.transcripts.length - 1 ){
                index = this.transcripts.length - 1;
            }else if( index < 0 ){
                return await this.stop();
            }
            return await this.seek( this.transcripts[ index ].timestamp );
        },

        prev(){
            this.gotoIndex( this.stats.current_index + 1 );
        },

        next(){
            this.gotoIndex( this.stats.current_index - 1 );
        },

        async play(){

            this.autoHideControls();

            if( this.is_video ){
                this.video.play();
            }

            if( this.is_audio ){
                this.audio.play();
            }
        },

        async pause(){
            if( this.is_video ){
                this.video.pause();
            }
            if( this.is_audio ){
                this.audio.pause();
            }
        },

        async stop(){
            await this.seek(0);
            await this.pause();
        },

        async initVolume(){

            // Set volume status from cookie.

            const cookie_volume = this.$cookies.get('volume');
            let player_volume = 0;
            if( this.is_video ){
                player_volume = await this.video.getVolume() * 100;
            }
            if( this.is_audio ){
                player_volume = this.audio.volume * 100;
            }
            this.stats.volume = cookie_volume === null ? player_volume : parseInt( cookie_volume );
            await this.updatePlayerVolume();

            // Set volume muted status from cookie.

            await this.$nextTick(() => {
                const cookie_muted = this.$cookies.get('volume_muted');
                this.stats.volume_muted = cookie_muted === null ? false : !!parseInt( cookie_muted );
                this.updatePlayerVolume();
            });

        },

        async initVideoPlayer(){

            this.video = new Vimeo( this.$refs.preview, {
                id: this.vimeo_id,
                loop: false,
                autoplay: false,
                controls: false,
                color: 'FFADEF',
                muted: true,
                responsive: false,
            });

            await this.onPlayerReady();

            this.video.on('play', () => this.onPlay());
            this.video.on('pause', () => this.onPause());
            this.video.on('timeupdate', update => this.onTimeupdate(update));
            this.video.on('ended', () => this.onEnded());
            this.video.on('bufferstart', () => this.onBufferStart());
            this.video.on('bufferend', () => this.onBufferEnd());

        },

        async initAudioPlayer(){

            this.audio = new Audio( this.podcast.url );

            this.audio.onplay = () => this.onPlay();
            this.audio.onpause = () => this.onPause();
            this.audio.ontimeupdate = () => this.onTimeupdate();
            this.audio.onloadedmetadata = () => this.onPlayerReady();
            this.audio.onended = () => this.onEnded();
            this.audio.onwaiting = () => this.onBufferStart();
            this.audio.oncanplay = () => this.onBufferEnd();

        },

        showShareModal(){

        },


        fixHeight(){
            let height = jQuery(window).height();
            const $headers = jQuery('.header');
            let header_height = 0;
            for ( let i = 0; i < $headers.length; i++ ){
                header_height += $headers.eq(i).outerHeight();
            }
            if( !this.stats.fullscreen ) height -= header_height;
            // jQuery('.player, .player-sidebar').height( Math.floor( height ) );
        },

        startProject(){
            window.top.location = this.create_project_url;
        },

        startShortProject(){
            window.top.location = this.create_short_project_url;
        },

        close(){
            window.parent
        },

        async fetchActivities(){
            this.activities = await API.elements.bulk({
                type: 'activity',
                owner: 'dfc',
                groups: ['stage:warmup', 'stage:intro'],
            });
        },

        hideSidebarFunc() {
            this.stats.sidebar = null
        }

    },

    beforeMount() {

        if( this.current_user ){
            this.fetchActivities();
        }

        // We must reverse to quickly find using timestamp.

        this.transcripts = this.podcast?.transcript_data
            ?.reduce((prev, section) => prev.concat({
                timestamp: this.utils.textToTimestamp(section.timestamp),
                visual: section?.visuals?.length ? section?.visuals[0] : null,
                segments: section.segments,
                title: section.title,
            }), [])
            .reverse();

    },

    async mounted() {

        if ( this.hideSidebar ) this.hideSidebarFunc()

        if( this.is_video ){
            await this.initVideoPlayer();
        }
        if( this.is_audio ){
            await this.initAudioPlayer();
        }

        await this.initVolume();

        this.fixHeight();
        jQuery(window).on('load', this.fixHeight);
        jQuery(window).on('resize', this.fixHeight);
        jQuery(document).on('fullscreenchange', this.onFullscreenChange);

        mixpanel.track('PODCAST/PLAY', {podcast: this.podcast?.short_name, email: this.$page.props.user.email});

        setTimeout(() => {
            // jQuery('body').height(10000);
            this.fixHeight();
        }, 3000);

    },

    beforeUnmount() {

        jQuery(document).off('fullscreenchange', this.onFullscreenChange);
        jQuery(window).off('load', this.fixHeight);
        jQuery(window).off('resize', this.fixHeight);


        this.video?.unload().then(() => {
            this.video.off('play');
            this.video.off('pause');
            this.video.off('timeupdate');
            this.video.off('ended');
            this.video.off('bufferstart');
            this.video.off('bufferend');
            this.video = undefined;
            delete this.video;
        })
    }

}
</script>
<style lang="scss">
.podcast-player{
    iframe{
        display: none;
    }

    .showing-visuals{
        iframe{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}
</style>

<style lang="scss" scoped>
.podcast-player{
    // padding: 0 1rem;
    margin: auto;
    position: relative;
    z-index: 1;
    background: $body-bg;

    &:focus, &:focus-visible{
        outline: none;
    }
}

.player-wrap{
    display: flex;
    //margin-left: -1rem;
    //margin-right: -1rem;

    @media (max-width: 1400px){
        flex-direction: column;
    }
}

// .player, .player-sidebar{
//     padding: 0 1rem;
// }

.details{
    text-align: center;
    padding-right: 1rem;
    display: block;
    align-self: center;
    width: 100%;
}

.transcripts{
    text-align: left;
}

.player-sidebar{
    overflow: auto;
    padding: 0 0 0 1.5rem;
    display: flex;
    width: 480px;
    > * {
        margin: 1rem 0;
    }
    @media (max-width: 1400px) {
        margin: 0 auto;
    }
}


.is-fullscreen{
    &.player-sidebar{
        > * {
            padding-right: 1.5rem;
        }
    }
}

.goal{
    max-width: 120px;
    margin: 1rem auto 2rem;
    border: white solid 3px;
    border-radius: .3rem;
    box-shadow: rgba($dark, .15) 0 2px 3px;
}

.goal-image{
    display: block;
    width: 100%;
    height: auto;
}


.player {
    position: relative;
    // position: sticky;
    // top: 130px;
    flex: 1 1 auto;
    // min-height: 80vh;
    width: 100%;
    aspect-ratio: 16/9;

    video{
        width: 100%;
        height: 100%;
    }
}

// .audio{
//     .player{
//         height: 80vh;
//         min-height: 620px;
//     }
// }

.player-preview{
    flex-grow: 1;
    width: 100%;
    height: 100%;
    background: transparent no-repeat center;
    background-size: cover;
    position: relative;
    user-select: none;

    &:after{
        content: '';
        background: transparent;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    &.showing-visuals{
        background-size: contain;
    }
}

.player-controls{
    padding: 0.6rem 0;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($dark, 0.9);
    opacity: 1;
    transition: opacity .3s;
    color: white;
    @media (max-width: 450px) {
        padding: 0;
    }
}

.hide-controls{
    .player-controls{
        opacity: 0;
    }

    .player{
        cursor: none;
    }
}

.hide-controls{
    .player-controls{
        opacity: 0;
    }
}

.basic-controls{
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 0.6rem;

    @media (max-width: 600px) {
        padding: 0 0 0 0.6rem;
    }

    a{
        display: inline-flex;
        width: 3rem;
        height: 3rem;
        align-items: center;
        justify-content: center;
        padding: 0.8rem;

        @media (max-width: 768px) {
            width: 2.5rem;
            height: 2.5rem;
            padding: 0.5rem;

            @media (max-width: 600px) {
                width: 2rem;
                height: 2rem;
                @media (max-width: 450px) {
                    width: 1rem;
                    height: 1rem;
                    padding: 0.2rem;
                }
            }
        }
        .icon{
            width: 100%;
            height: auto;
        }

        // &.play{
        //     padding: 0.5rem;;
        // }
    }
}

.timer{
    flex: 0 0 100px;
    text-align: center;
    @media (max-width: 600px) {
        font-size: 14px;
        flex: 0 0 80px;
        @media (max-width: 500px) {
            display: none;
        }
    }
}

.seeker-control{
    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 1rem;
    margin-right: 1rem;
    padding: 2rem 0;

    @media (max-width: 600px) {
        padding: 0;
        @media (max-width: 450px) {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }
    }

    &:hover{
        .track{
            .handle{
                width: 18px;
                height: 18px;
            }
        }
    }
}

.track{
    width: 100%;
    height: 6px;
    background: rgba($light, .3);
    border-radius: 6px;
    position: relative;
    cursor: pointer;

    .complete{
        background: $light;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        border-radius: 6px;
        z-index: 3;
    }

    .handle{
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(50%, -50%);
        width: 10px;
        height: 10px;
        background: $secondary;
        border-radius: 50%;
        transition: width .3s, height .3s;
        cursor: pointer;
    }

    .steps{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        .step{
            position: absolute;
            left: 0;
            bottom: .5rem;
            width: 0;
            height: 0;
            border: transparent solid 6px;
            border-top-color: $primary;
            transform: translateX(-50%);
            transition: border .3s;
            z-index: 1;
            border-radius: 50%;

            &:after{
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                border-left: $primary solid 1px;
                height: 0;
                opacity: 0;
                transition: height .3s, opacity .2s;
            }

            &:hover{
                border-width: 16px;
                z-index: 2;
                border-radius: 0;

                &:after{
                    height: 1rem;
                    opacity: 1;
                }

                .text{
                    height: 1.2rem;
                    padding: 0.8rem 0.5rem;
                    bottom: 1rem;
                    opacity: 1;
                }
            }
        }

        .text{
            background: $primary;
            position: absolute;
            bottom: .5rem;
            left: 0;
            transform: translateX(-50%);
            text-wrap: none;
            white-space: nowrap;
            color: white;
            height: 0;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            border-radius: .3rem;
            opacity: 0;
            transition: all .3s;
        }
    }
}

.actions{
    padding-right: 1rem;
    @media (max-width: 450px) {
        padding-right: 0;
        .btn {
            padding: 0.1rem 0.5rem;
        }
    }
}

.btn-volume{
    &:hover{
        .volume-control{
            display: block;
        }
    }
}

.volume-control{
    display: none;
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    background: $dark;
    padding: 0.6rem 0;
    border-radius: .3rem .3rem 0 0;

    input{
        -webkit-appearance: slider-vertical;
        width: 100%;
    }
}

.start-project{
    background: darken(white, 10%);
    padding: 1rem 0 0;
    margin-top: 1rem;
    border-radius: .3rem;
    text-align: center;

    .title{
        font-size: .8rem;
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    &-actions{
        display: flex;
        align-items: stretch;
        justify-content: center;
    }

    .btn{
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 0 0 50%;
        width: 50%;
        font-size: 1rem;
        font-weight: $font-weight-bold;
        padding: 1rem .8rem;

        &:first-child{
            border-radius: 0 0 0 .3rem;
            border-right: darken(white, 10%) solid 1px;
        }

        &:last-child{
            border-radius: 0 0 .3rem 0;
        }

        span{
            display: block;
            font-size: .8em;
            color: darken($light, 10%);
            font-weight: $font-weight-normal;
        }
    }
}

.podcast-wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    height: 100vh;
}

.header{
    display: flex;
    align-items: center;
    background: $light;
    box-shadow: rgba(black, .1) 0 3px 5px;
    position: relative;
    z-index: 2;
    gap: 1rem;

    .goal-image{
        flex: 160px 0 0;
        width: 160px;
        @media (max-width: 650px) {
            flex: 100px 0 0;
            width: 100px;
        }

        img{
            width: 100%;
            height: auto;
        }
    }

    .podcast-info{
        .title{
            font-size: 2.1rem;
            font-weight: $font-weight-bold;
            @media (max-width: 991px) {
                font-size: 1.5rem;
                @media (max-width: 650px) {
                    font-size: 1.1rem;
                }
            }
        }

        .desc{
            font-size: 1.1rem;
            @media (max-width: 991px) {
                font-size: 0.9rem;
                @media (max-width: 650px) {
                    font-size: 0.7rem;
                }
            }
        }
    }

    .actions{
        display: flex;
        align-items: center;
        margin: 1rem .6rem auto auto;

        .share{
            display: block;
            padding: .4rem .8rem;
            background: darken($light, 5%);
            font-size: 1.1rem;
            text-decoration: none;
            transition: background-color .3s;
            color: $dark;
            font-weight: $font-weight-semibold;
            border-radius: .3rem;

            &:hover{
                // background: darken($light, 10%);
                color: $feel;
            }
        }

        .close{
            width: 2.2rem;
            height: 2.2rem;
            margin-left: 1rem;
            display: flex;
            font-size: 1.8rem;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            background: darken($light, 25%);
            color: white;
            transition: background-color .3s;
            cursor: pointer;
            opacity: 1;
            line-height: 0;

            &:hover{
                background: $danger;
            }
        }
    }
}

</style>
